module.exports = __webpack_public_path__ + "static/media/shufu-logo.7da1985c.png";